let exchangeRate = 0

const getExchangeRate = (cb) => {
  if (exchangeRate) {
    cb(exchangeRate)
  } else {
    const http = new XMLHttpRequest()
    http.onreadystatechange = () => {
      if (http.readyState === 4 && http.status === 200) {
        const res = JSON.parse(http.responseText)
        const rate = parseFloat(res.data.amount)

        exchangeRate = rate
        cb(rate)
      }
    }
    http.open('GET', 'https://api.coinbase.com/v2/prices/ETH-USD/buy', true)
    http.send()
  }
}

export default getExchangeRate



// WEBPACK FOOTER //
// ./src/lib/DollarEthRate.js